export default __webpack_public_path__ + "static/media/qa.0ab0688a.svg";